module.exports = __webpack_public_path__ + "img/smart-farm.2dd442a3.png";